import * as React from 'react';
type Props = {
  className?: string;
};
export function Swap({ className }: Props) {
  return (
    <svg
      width="1em"
      height="1em"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      data-testid="utility-swap"
      className={className}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M8.24264 12.7574L9.65685 14.1716L7.828 15.9994L19 16V18L7.827 17.9994L9.65685 19.8284L8.24264 21.2426L4 17L8.24264 12.7574ZM15.7574 3.75735L20 8L15.7574 12.2426L14.3431 10.8284L16.173 8.99936L5 9V7L16.172 6.99935L14.3431 5.17157L15.7574 3.75735Z"
        fill="currentColor"
      />
    </svg>
  );
}
